$(document).ready(function () {
    'use strict';

    var MOBILE_DEVICE_REGEXP = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;

    var isMobileDetected = MOBILE_DEVICE_REGEXP.test(navigator.userAgent);

    if (isMobileDetected) {
        var toggleMobileTooltip = function (event) {
            var $tooltip = $(this).find(".rfs-mobile-tooltip");

            if ($tooltip.length) {
                $tooltip.remove();
            }

            var target = event.target;

            if (target.classList.length && Array.from(target.classList).includes('rfs-icon2')) {
                if ($tooltip.length) {
                    $tooltip.remove();
                } else {
                    event.target.insertAdjacentHTML('beforeend', '<span class="rfs-mobile-tooltip">' + event.target.title + '</span>')
                }
            }
        }

        $('.js-broadcast-container').each(function (event) {
            var $self = $(this);

            if (!$self || !$self.length) return;

            $self.on('click', toggleMobileTooltip)
        });
    }
});
